import { render } from "./ClassDiaries.vue?vue&type=template&id=17bc7919&scoped=true&ts=true"
import script from "./ClassDiaries.vue?vue&type=script&lang=ts"
export * from "./ClassDiaries.vue?vue&type=script&lang=ts"

import "./ClassDiaries.vue?vue&type=style&index=0&id=17bc7919&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bc7919"]])

export default __exports__